import { createRouter, createWebHistory } from 'vue-router'
import LoginComponent from '../views/LoginComponent.vue'
import RegisterComponent from '../views/RegisterComponent.vue'
import HomeComponent from '../views/HomeComponent.vue'
import PannelComponent from '../components/other/PannelComponent.vue'
import DocumentsComponent from '../components/other/DocumentsComponent.vue'
import ShopComponent from '../components/order/ShopComponent.vue'
import StateComponent from '../components/order/StateComponent.vue'
import OrdersComponent from '../components/finance/OrdersComponent.vue'
import InviteComponent from '../components/finance/InviteComponent.vue'
import PersonComponent from '../components/user/PersonComponent.vue'
import HelpComponent from '../components/user/HelpComponent.vue'
import FlowComponent from '../components/user/FlowComponent.vue'
import ShopConfigureComponent from '../components/order/ShopConfigureComponent.vue'
import DOCComponent from '../components/docx/DOCComponent.vue'
import StatusComponent from '../components/order/StatusComponent.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
const routes = [
  {
    path: '/',
    redirect: 'login'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginComponent
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterComponent
  },
  {
   path: '/home',
    name: 'home',
    component: HomeComponent,
    redirect: "pannel",
    children: [
      {
       path: '/pannel/:from?/:lang?',
        name: "pannel",
        component: PannelComponent
      },
      {
       path: '/document',
        name: "document",
        component: DocumentsComponent
      },
      {
       path: '/shop/:from?/:lang?',
        name: "shop",
        component: ShopComponent
      },
      {
        path: '/state/:from?/:lang?',
        name: "state",
        component: StateComponent
      },
      {
       path: '/orders/:from?/:lang?',
        name: "orders",
        component: OrdersComponent
      },
      {
       path: '/invite',
        name: "invite",
        component: InviteComponent
      },
      {
       path: '/person',
        name: "person",
        component: PersonComponent
      },
      {
       path: '/help',
        name: "help",
        component: HelpComponent
      },
      {
       path: '/flow',
        name: "flow",
        component: FlowComponent
      },
      {
       path: '/shopConfigure/:obj',
        name: 'shopConfigure',
        component: ShopConfigureComponent
      },
      {
       path: '/status/:params',
        name: 'status',
        component: StatusComponent
      },

    ]
  },
  {
   path: '/showDocx',
    name: 'dOCComponent',
    component: DOCComponent
  },
  {
   path: '/forgetPasswords',
    name: 'forgetPassword',
    component: ForgetPassword
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

/**
 * 全局前置路由守卫，每一次路由跳转前都进入这个 beforeEach 函数
 */
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register' || to.path === '/' || to.path === '/showDocx' || to.path === '/forgetPasswords') {
    // 登录或者注册才可以往下进行
    next();
  } else {
    // 获取 token
    const token = localStorage.getItem('token');
    // token 不存在
    if (token === null || token === '') {
      next('/login');
    } else {
      next();
    }
  }
});

export default router
